export default function initClientSidenav() {
  const nav = document.getElementById('sideNav')
  const mobCloseBtn = document.querySelector('.mob-close-btn')
  const hambTrigger = document.getElementById('hambSidenavTrigger')
  const mainEl = document.getElementById('mainWrapperElement')
  const railBreakpoint = 900
  const fullSidebarBreakpoint = 1400

  if (!nav || !mainEl) return

  function setTriggerState(expanded) {
    hambTrigger?.setAttribute('aria-expanded', expanded ? 'true' : 'false')
  }

  function closeSidenav() {
    nav.classList.remove('sidenav-menu-elements')
    nav.classList.toggle('sidenav-closed', window.innerWidth < railBreakpoint)
    nav.setAttribute('aria-hidden', window.innerWidth < railBreakpoint ? 'true' : 'false')
    nav.inert = window.innerWidth < railBreakpoint

    mainEl.classList.remove('sidenav-opened')
    document.body.classList.remove('client-sidenav-overlay-open')
    hambTrigger?.classList.remove('closed-mobile-trigger')
    setTriggerState(false)
  }

  function syncSidenavMode() {
    const isDrawer = window.innerWidth < railBreakpoint
    const isFullSidebar = window.innerWidth >= fullSidebarBreakpoint

    nav.classList.remove('sidenav-menu-elements')
    mainEl.classList.remove('sidenav-opened')
    document.body.classList.remove('client-sidenav-overlay-open')
    hambTrigger?.classList.remove('closed-mobile-trigger')
    setTriggerState(false)

    nav.classList.toggle('sidenav-closed', isDrawer)
    nav.setAttribute('aria-hidden', isDrawer ? 'true' : 'false')
    nav.inert = isDrawer

    if (isFullSidebar) {
      nav.classList.remove('sidenav-closed')
      nav.setAttribute('aria-hidden', 'false')
      nav.inert = false
    }
  }

  if (hambTrigger) {
    hambTrigger.addEventListener('click', function () {
      nav.classList.remove('sidenav-closed')
      nav.classList.add('sidenav-menu-elements')
      nav.removeAttribute('inert')
      nav.setAttribute('aria-hidden', 'false')

      hambTrigger.classList.add('closed-mobile-trigger')
      hambTrigger.setAttribute('aria-expanded', 'true')
      mainEl.classList.add('sidenav-opened')
      document.body.classList.add('client-sidenav-overlay-open')
    })
  }

  if (mobCloseBtn) {
    mobCloseBtn.addEventListener('click', closeSidenav)
  }

  document.addEventListener('click', function (event) {
    if (window.innerWidth >= fullSidebarBreakpoint) return
    if (!nav.classList.contains('sidenav-menu-elements')) return
    if (nav.contains(event.target)) return
    if (hambTrigger && hambTrigger.contains(event.target)) return

    closeSidenav()
  })

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && nav.classList.contains('sidenav-menu-elements')) {
      closeSidenav()
      hambTrigger?.focus()
    }
  })

  // Collapsible nav groups (Marketing). The group holding the current page is
  // rendered open by the blade, so the section never appears collapsed on the
  // very page it contains.
  nav.querySelectorAll('[data-nav-group]').forEach(function (toggle) {
    toggle.addEventListener('click', function (event) {
      const group = toggle.closest('.nav-link-group')
      if (!group) return

      // In the collapsed rail the submenu is hidden by CSS, so expanding would
      // do nothing visible. The caret is hidden by exactly the same rule, so
      // its being unrendered is the honest signal that there is no room - let
      // the anchor navigate to the section instead of swallowing the click.
      const caret = toggle.querySelector('.nav-group-caret')
      if (caret && caret.offsetParent === null) return

      event.preventDefault()

      const open = group.classList.toggle('is-open')
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
    })
  })

  window.addEventListener('resize', syncSidenavMode)
  syncSidenavMode()
}
